export const categories = [
  {
    slug: 'free-website-builders',
    name: '免费建站平台',
    description: '零代码拖拽式建站工具，无需技术基础即可快速搭建专业网站',
    icon: 'ri-layout-4-line',
    count: 12,
    color: 'accent',
  },
  {
    slug: 'free-domains',
    name: '免费域名申请',
    description: '获取免费顶级域名和二级域名的渠道与方法汇总',
    icon: 'ri-link',
    count: 8,
    color: 'primary',
  },
  {
    slug: 'free-hosting',
    name: '免费主机空间',
    description: '稳定可靠的免费虚拟主机和云服务器资源推荐',
    icon: 'ri-server-line',
    count: 15,
    color: 'secondary',
  },
  {
    slug: 'free-cdn',
    name: '免费CDN加速',
    description: '全球节点加速你的网站访问速度，免费CDN服务大盘点',
    icon: 'ri-rocket-line',
    count: 6,
    color: 'accent',
  },
  {
    slug: 'free-ssl',
    name: '免费SSL证书',
    description: '为网站启用HTTPS加密，免费SSL证书申请教程与工具',
    icon: 'ri-shield-check-line',
    count: 5,
    color: 'primary',
  },
  {
    slug: 'free-templates',
    name: '免费网站模板',
    description: '高质量的HTML模板、WordPress主题等免费网站素材资源',
    icon: 'ri-file-copy-line',
    count: 20,
    color: 'secondary',
  },
  {
    slug: 'free-seo-tools',
    name: '免费SEO工具',
    description: '提升网站搜索引擎排名的免费工具与实用技巧分享',
    icon: 'ri-search-eye-line',
    count: 10,
    color: 'accent',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});